/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DeleteIssuanceProfileRequestBody = {
  /**
   * The profile id.
   */
  id: string;
};

/** @internal */
export type DeleteIssuanceProfileRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const DeleteIssuanceProfileRequestBody$outboundSchema: z.ZodMiniType<
  DeleteIssuanceProfileRequestBody$Outbound,
  DeleteIssuanceProfileRequestBody
> = z.object({
  id: z.string(),
});

export function deleteIssuanceProfileRequestBodyToJSON(
  deleteIssuanceProfileRequestBody: DeleteIssuanceProfileRequestBody,
): string {
  return JSON.stringify(
    DeleteIssuanceProfileRequestBody$outboundSchema.parse(
      deleteIssuanceProfileRequestBody,
    ),
  );
}
